import Column from '@app/components/layout/Column'
import useMediaQuery from '@app/util/useMediaQuery'
import { useLanguage } from '@i18n/useLanguage'
import { i18n } from '@i18n/index'
import { Event } from '@app/components/blocks/event/Event'
import { SectionHeader } from '@app/components/blocks/sectionHeader/SectionHeader'
import { BlogCard } from '@app/components/blocks/card/BlogCard'
import Row from '@app/components/layout/Row'
import { GeoViewModel } from './models'

export const Current = ({ region: _region }: { region: GeoViewModel }) => {
  const isMobile = useMediaQuery()
  const _largerGap = isMobile ? '2rem' : '3.5rem'
  const _smallerGap = isMobile ? '1rem' : '2rem'
  const [language, _] = useLanguage()
  const translations = i18n.languages[language].app.regionPage
  return (
    <Column alignItems="stretch">
      <SectionHeader title={translations.events} />
      <Event
        date={14}
        month="Oktober"
        category="INFORMATIE"
        title="Informatiebijeenkomst over CPO-bouwen in Mill"
        description="Informatiebijeenkomst over CPO-bouwen in Mill"
        time="10:00 - 12:00"
        location="Amsterdam"
      />
      <Event
        date={14}
        month="Oktober"
        category="INFORMATIE"
        title="Informatiebijeenkomst over CPO-bouwen in Mill"
        description="Informatiebijeenkomst over CPO-bouwen in Mill"
        time="10:00 - 12:00"
        location="Amsterdam"
      />
      <Event
        date={14}
        description="Informatiebijeenkomst over CPO-bouwen in Mill"
        month="Oktober"
        category="INFORMATIE"
        title="Informatiebijeenkomst over CPO-bouwen in Mill"
        time="10:00 - 12:00"
        location="Amsterdam"
      />
      <Event
        date={14}
        month="Oktober"
        category="INFORMATIE"
        title="Informatiebijeenkomst over CPO-bouwen in Mill"
        description="Informatiebijeenkomst over CPO-bouwen in Mill"
        time="10:00 - 12:00"
        location="Amsterdam"
      />
      <SectionHeader title={translations.news} />
      <Row style={{ gap: '1.5rem' }}>
        <Column>
          <BlogCard
            image="https://images.pexels.com/photos/2917838/pexels-photo-2917838.jpeg"
            meta="Nieuws"
            title="Tinyhouses Westpark het groenste kleine wijkje van Stad"
          />
          <BlogCard
            image="https://images.pexels.com/photos/2917838/pexels-photo-2917838.jpeg"
            meta="Nieuws"
            title="Tinyhouses Westpark het groenste kleine wijkje van Stad"
            orientation="horizontal"
          />
          <BlogCard
            image="https://images.pexels.com/photos/2917838/pexels-photo-2917838.jpeg"
            meta="Nieuws"
            title="Tinyhouses Westpark het groenste kleine wijkje van Stad"
            orientation="horizontal"
          />
        </Column>
        <Column>
          <BlogCard
            image="https://images.pexels.com/photos/2917838/pexels-photo-2917838.jpeg"
            meta="Nieuws"
            title="Tinyhouses Westpark het groenste kleine wijkje van Stad"
            orientation="horizontal"
          />
          <BlogCard
            image="https://images.pexels.com/photos/2917838/pexels-photo-2917838.jpeg"
            meta="Nieuws"
            title="Tinyhouses Westpark het groenste kleine wijkje van Stad"
            orientation="horizontal"
          />
          <BlogCard
            image="https://images.pexels.com/photos/2917838/pexels-photo-2917838.jpeg"
            meta="Nieuws"
            title="Tinyhouses Westpark het groenste kleine wijkje van Stad"
            orientation="horizontal"
          />
          <BlogCard
            image="https://images.pexels.com/photos/2917838/pexels-photo-2917838.jpeg"
            meta="Nieuws"
            title="Tinyhouses Westpark het groenste kleine wijkje van Stad"
          />
        </Column>
      </Row>
    </Column>
  )
}
